// extracted by mini-css-extract-plugin
export var fadeIn = "_lg-1";
export var modalContent = "_lg-3";
export var overlay = "_lg-0";
export var popoverContent = "_lg-2";
export var results = "_lg-5";
export var searchInputWrapper = "_lg-4";